import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { BONOS, DECO_STACK, STACK_COPY, STACK_HIGHLIGHTS, TOMOS } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';

/**
 * STACK COMPLETO. Todo lo que entra en el kit, visto de una sola vez:
 * los dos tomos, los cinco bonos y las cookies alrededor.
 */
export function TomosSection() {
  return <section className="relative overflow-hidden bg-ivory py-14 sm:py-20" aria-labelledby="tomos-title" data-id="element-375" data-mp="xd5x3e9hc117">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-376" data-mp="11er6uqqpvz76">
        <div className="max-w-3xl" data-id="element-377" data-mp="16dc9sxxcswzb">
          <SectionTag data-id="element-378" data-mp="16cax6p0ow2fh">El kit completo</SectionTag>
          <h2 id="tomos-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-379" data-mp="1bc5m4n0wmhxw">
            Todo lo que necesitás para empezar con tus New York Cookies
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-380" data-mp="2mq103sg2oknj">
            {STACK_COPY}
          </p>
        </div>

        <div className="mt-9 grid gap-9 lg:grid-cols-12 lg:items-center lg:gap-12" data-id="element-381" data-mp="2qlw53fe8jy9t">
          {/* Composición: los dos tomos + una cookie que rompe el borde. */}
          <div className="relative lg:col-span-6" data-id="element-382" data-mp="2hlzakx56056u">
            <div className="mockup-ground absolute bottom-2 left-1/2 h-10 w-[70%] -translate-x-1/2 blur-md" aria-hidden data-id="element-383" data-mp="2copnvp95u7mp" />
            <img src={HERO_IMAGE_URL} alt="Los dos tomos de 100 New York Cookies con la colección de cookies delante." loading="lazy" decoding="async" className="animate-breathe relative mx-auto max-h-[300px] w-full object-contain drop-shadow-[0_26px_44px_rgba(51,39,34,0.24)] sm:max-h-[420px]" data-id="element-384" data-mp="27qnvuetraxz3" />
            <img src={DECO_STACK} alt="" aria-hidden loading="lazy" style={{
            ['--drift-rot' as string]: '6deg'
          }} className="animate-drift absolute -bottom-3 right-0 h-24 w-24 rounded-full object-cover shadow-bakery sm:h-32 sm:w-32" data-id="element-385" data-mp="1oxk0mp0w4d2d" />
          </div>

          <div className="lg:col-span-6" data-id="element-386" data-mp="11bhqvsaox7a7">
            <ul data-id="element-387" data-mp="11cjail5rv23j">
              {TOMOS.map(tomo => <li key={tomo.id} className="border-t border-warm py-4" data-id="element-388" data-mp="15d3bjztgupuy">
                  <p className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-caramel" data-id="element-389" data-mp="15f5y29veu0ux">
                    {tomo.label}
                  </p>
                  <p className="mt-1.5 font-display text-[1.05rem] leading-snug text-charcoal sm:text-[1.25rem]" data-id="element-390" data-mp="1y0per6ys7sha">
                    {tomo.title}
                  </p>
                </li>)}
            </ul>

            {/* Los cinco bonos, en pequeño: acá se cuentan, no se explican. */}
            <p className="mt-7 font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-[#F47A2A] sm:text-[0.66rem]" data-id="element-391" data-mp="2c0qcwennwlt2">
              + 5 bonos digitales de regalo
            </p>
            <motion.ul initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="no-scrollbar mt-3 flex snap-x snap-mandatory gap-3 overflow-x-auto pb-1 pt-2 sm:mt-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:overflow-visible sm:pt-0" data-id="element-392" data-mp="5c7vn5m6ugra">
              {BONOS.map(bono => <li key={bono.id} className="w-[38%] shrink-0 snap-start sm:w-auto" data-id="element-393" data-mp="3dkybc4nn712r">
                  <img src={bono.image} alt={`Portada del ${bono.label}: ${bono.title}.`} loading="lazy" decoding="async" className="aspect-[3/4] w-full rounded-2xl bg-cream object-contain p-1 shadow-bakery-sm" data-id="element-394" data-mp="3dn2mn7nvf2d2" />
                  <p className="mt-2 font-sans text-[0.68rem] font-bold leading-snug text-charcoal" data-id="element-395" data-mp="12tgco89eltb0">
                    {bono.title}
                  </p>
                </li>)}
            </motion.ul>
          </div>
        </div>

        <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-warm pt-6 sm:grid-cols-5" data-id="element-396" data-mp="3dgafvh5gkbha">
          {STACK_HIGHLIGHTS.map(item => <div key={item.id} className="text-center sm:text-left" data-id="element-397" data-mp="3mggnimeh6h8j">
              <dt className="sr-only" data-id="element-398" data-mp="3mecc7je8yfy8">{item.label}</dt>
              <dd data-id="element-399" data-mp="3reqojdmvsc22">
                <span className="block font-display text-[1.5rem] leading-none text-caramel sm:text-[2rem]" data-id="element-400" data-mp="3rfa3clh8ikbv">
                  {item.value}
                </span>
                <span className="mt-1 block font-sans text-[0.58rem] font-semibold leading-tight text-charcoal-mid sm:text-[0.68rem]" data-id="element-401" data-mp="4zyu5g6hlbg6">
                  {item.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}